<template>
  <header id="header" v-if="headerStyle || (brandQuery && brandQuery.hideHeader !== 'true')">
    <div class="leftBtn">
      <a @click="$router.go(-1)" class="backBtn" v-if="isBack">
        <i :style="{ color: headerStyle.toolbarTitleColor }" class="UXicon-webchat_arrow_left"></i>
      </a>
      <router-link class="history" to="/webchat/history" v-if="isHistory">
        <i :style="{ color: headerStyle.toolbarTitleColor }" class="UXicon-webchat_chating_history"></i>
      </router-link>
    </div>
    <div
      :style="{
        paddingLeft: toolbarHeaderStyle['padding-left'],
        backgroundColor: toolbarHeaderStyle['background-color'],
        backgroundImage: toolbarHeaderStyle['background-image'],
        paddingRight: getToolbarRightPadding
      }"
      class="chatTop"
    >
      <div v-if="title" class="title" :style="{ color: headerStyle.toolbarTitleColor }">
        {{ title }}
      </div>
      <div v-else>
        <dl
          @click="showHeader"
          ref="titleData"
          :class="{ show: isShowHeader }"
          :style="{ backgroundImage: 'url(' + headerStyle.toolbarIconPath + ')' }"
        >
          <dt :style="{ color: headerStyle.toolbarTitleColor }">{{ headerStyle.toolbarTitle }}</dt>
          <dd :style="{ color: headerStyle.toolbarCommentColor }">{{ headerStyle.toolbarComment }}</dd>
        </dl>
      </div>
    </div>
    <div class="ritBtn">
      <a class="hiddenBtn" @click="hiddenFrame" v-if="isShowHideBtn">
        <i :style="{ color: headerStyle.toolbarTitleColor }" class="UXicon-minus"></i>
      </a>
      <a class="closeBtn" @click="closeChatRoom" v-if="!isBack">
        <i :style="{ color: headerStyle.toolbarTitleColor }" class="UXicon-close"></i>
      </a>
    </div>
  </header>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'Header',
  props: {
    isBack: {
      type: Boolean,
      default: false
    },
    isHistory: {
      type: Boolean,
      default: false
    },
    isHidden: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      headerStyle: {},
      brandQuery: window.sessionStorage.getItem('BRAND_QUERY') ? JSON.parse(window.sessionStorage.getItem('BRAND_QUERY')) : undefined,
      toolbarHeaderStyle: {},
      isShowHeader: false
    };
  },
  computed: {
    ...mapGetters(['chatRoomData', 'brandId']),
    isShowHideBtn() {
      // 아몬즈 업체 커스텀을 위해 임시로 조건 추가.
      // 추후 옵션화 진행 시, 아래 조건은 삭제 필요.
      const brandKey = this.brandQuery ? this.brandQuery.brandKey : null;
      if (!brandKey) return false;

      if (process.env.NODE_ENV === 'production') {
        const amondsBrandKeyArr = [
          '20240927101228DUGsHicP1T77lYkUElJooA',
          '20240927101228r0NHNmtO2Bjri5jSlRoHgA',
          '20241024024919wkF0YKKeTmjYIotIPFLLrQ',
          '20241024024919cEIFMJJkU9iMpro0hRQ1jw',
          '20240925071510sUS_EfY4hN5TlINqhjFQqg',
          '2024092507151090eB9KA2ZSEa8Cm9BfqfgQ',
          '20240927033212EkbOMSc80I_yUdiOcw4Gow',
          '20240927033212rkOrYONXv9qTT6HKjMp2hA'
        ];
        if (amondsBrandKeyArr.indexOf(brandKey) > -1) {
          return false;
        } else {
          if (this.brandQuery && this.brandQuery.appId && navigator.userAgent.indexOf(this.brandQuery.appId) > -1) {
            return true;
          } else {
            return this.$isIframe;
          }
        }
      } else {
        const testBrandKeyArr = ['80Y0KpLLJzBO3HL0gPU9jA', 'Y0CAQphbx94pH2q18Yh9hA'];
        if (testBrandKeyArr.indexOf(brandKey) > -1) {
          return false;
        } else {
          if (this.brandQuery && this.brandQuery.appId && navigator.userAgent.indexOf(this.brandQuery.appId) > -1) {
            return true;
          } else {
            return this.$isIframe;
          }
        }
      }
    },
    getToolbarRightPadding() {
      return this.isShowHideBtn ? '80px' : '52px';
    }
  },
  mounted() {
    this.headerStyle = this.chatRoomData.headerStyle;
    if (this.headerStyle) {
      this.toolbarHeaderStyle = {
        'padding-left': !this.isBack && !this.isHistory ? '30px' : '63px',
        'background-color': this.headerStyle.toolbarBackgroundColor,
        'background-image': this.headerStyle.toolbarBackgroundColor !== '' ? 'none' : 'linear-gradient(277deg, #3986d4, #ac51ff)'
      };
      if (this.brandQuery && !this.headerStyle.toolbarIconPath) {
        this.headerStyle.toolbarIconPath = `${process.env.VUE_APP_IMAGE_URL}/${
          this.brandQuery.channelType === 'chat' ? 'icon_webchat_v2' : 'icon_chatbot_v2'
        }.png`;
      }
    }
    window.addEventListener('resize', this.listenerResize);
  },
  methods: {
    listenerResize() {
      if (this.isShowHeader && this.$refs.titleData.clientHeight === 70) {
        this.isShowHeader = false;
      }
    },
    showHeader() {
      this.isShowHeader = !this.isShowHeader;
      if (this.isShowHeader) {
        setTimeout(() => {
          this.isShowHeader = this.$refs.titleData.clientHeight > 70;
        }, 50);
      }
    },
    hiddenFrame() {
      if (this.brandQuery.appId && navigator.userAgent.indexOf(this.brandQuery.appId) > -1) {
        const parameters = {
          func: 'onHideWebChat'
        };
        if (navigator.userAgent.indexOf('Android') > -1) {
          window.AppJSInterface.onHideWebChat();
        } else {
          window.webkit.messageHandlers.AppJSInterface.postMessage(parameters);
        }
      } else {
        if (this.$isIframe) {
          window.parent.postMessage(
            {
              messageType: 'HIDDEN_CHATROOM',
              data: 'close'
            },
            '*'
          );
        } else if (window.opener) {
          window.opener.postMessage(
            {
              messageType: 'HIDDEN_CHATROOM',
              data: 'close'
            },
            '*'
          );
        }
      }
    },
    closeFrame() {
      /**
       * close : 창만 종료
       * conclude: 대화 창 모두 종료
       */
      // window.sessionStorage.removeItem('HEADER_STYLE')
      // 헥토이노베이션 커스텀
      window.localStorage.removeItem('showHectoKeyboard');
      window.sessionStorage.removeItem('SCENARIO_CHECK_DATA');
      window.sessionStorage.removeItem('CURRENTLY_CHATROOM');
      try {
        if (this.brandQuery && this.brandQuery.appId && navigator.userAgent.indexOf(this.brandQuery.appId) > -1) {
          const parameters = {
            func: 'onCloseWebChat'
          };
          if (navigator.userAgent.indexOf('Android') > -1) {
            window.AppJSInterface.onCloseWebChat();
          } else {
            window.webkit.messageHandlers.AppJSInterface.postMessage(parameters);
          }
        } else {
          if (this.$isIframe) {
            window.parent.postMessage(
              {
                messageType: 'HIDDEN_CHATROOM',
                data: 'conclude'
              },
              '*'
            );
          } else {
            window.close();
          }
        }
      } catch (e) {
        window.close();
      }
    },
    setCloseChatRoom() {
      this.$http({
        method: 'POST',
        url: '/api/external/webchat/closeChatRoom',
        data: {
          chatRoomId: this.chatRoomData.chatRoomId
        }
      })
        .then((res) => {
          if (res.data.code !== 0) {
            this.$mitt.emit('DialogPopup', {
              useDialog: true,
              message: '<dl class="txt"><dd>' + res.data.message + '</dd></dl>'
            });
          } else {
            if (res.data.data && res.data.data.url) {
              this.$mitt.emit('DialogPopup', {
                useDialog: true,
                message: `<dl class="txt"><dt>설문조사하기</dt><dd class="autoScroll">${res.data.data.description}</dd></dl>`,
                getBtnCount: 2,
                getCloseBtnName: '다음에 할래요',
                getBtnName: '참여하기',
                getCloseButtonEvent: () => {
                  this.closeFrame();
                },
                getButtonEvent: () => {
                  this.$mitt.emit('windowOpen', {
                    url: res.data.data.url,
                    target: 'urlWindow',
                    features: 'height=' + screen.height + ',width=' + screen.width + 'fullscreen=no'
                  });
                  this.closeFrame();
                }
              });
            } else {
              this.closeFrame();
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    closeChatRoom() {
      this.$mitt.emit('DialogPopup', {
        useDialog: true,
        message: '<dl class="txt"><dt>상담종료하기</dt><dd>확인을 누르시면 상담이 종료됩니다.<br />종료하시겠습니까?</dd></dl>',
        getBtnCount: 2,
        getButtonEvent: () => {
          if (this.chatRoomData.isEnd || !this.chatRoomData.chatRoomId) {
            this.closeFrame();
            return false;
          } else {
            this.setCloseChatRoom();
          }
        }
      });
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.listenerResize);
  }
};
</script>
